import Vue from 'vue'
import vueResource from 'vue-resource'
import Axios from 'axios'

Vue.prototype.$axios = Axios;
Vue.use(vueResource);

const axios = Axios;

export default function request(url, params = { method: 'get', data: {} }) {
	params.header = {
	}

	return fetch(url, params);
}

function fetch(url, params) {
	return new Promise((resolve, reject) => {

		let result = {
			success: false,
			data: false,
			msg: '',
		}
        const responseType = url.indexOf('orderExport') !== -1 ? 'blob' : '';
		axios({
			url: url,
			headers: params.header,
			method: params.method,
			data: params.data,
			responseType: responseType,
			timeout: 10000,
			success: (res) => {
				console.log(res);
			},
			fail: (err) => {
				console.log(err);
			}
		}).then((r) => {

			if (r.status === 200) {
				//接口请求成功
				if (url.indexOf('/caihang/GetPriceByFile') !== -1) {
					// 批量检查文件接口-接口返回值特别处理
					const tempR = r.data;
					if (tempR.Success) {
						result.success = true;
						result.data = tempR.Data;
					} else {
						result.success = false;
						result.msg = tempR.Msg;
					}
				} else {
					result.success = true;
					result.data = r.data;
				}
				resolve(result);
			} else {
				console.log('========================= request.js');
				console.log(r);
				result.msg = r.data;
				resolve(result);
			}
		}).catch((e) => {
			console.log('request catch ==================');
			if (e.toString() === 'Error: timeout of 10000ms exceeded') {
				result.msg = '请求超时, 请检查网络状况重新操作';
			} else {
				result.msg = e;
			}
			resolve(result);
		});

		// }, 500)
	})
}




// WEBPACK FOOTER //
// ./src/utils/request_yin.js